<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            <h5>Upload Templates</h5>
                        </div>
                        <div class="card-body">
                            <div class="field-wrapper">
                                <div class="field-placeholder">Excel File *</div>
                                <input class="form-control" type="file" id="file" ref="file" name="file" />
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <button type="button" class="btn btn-danger" @click="reset">Reset</button>
                                    <button type="button" class="btn btn-primary" @click="uploadTemplate">Upload</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="card">
                        <div class="card-header">
                            <h5>Logs</h5>
                        </div>
                        <div class="card-body">
                            <ul class="list-group">
                                <li class="list-group-item list-group-item-danger" v-for="(error,key) in errors" :key="key">
                                    {{ error[0] }}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .btnn {
        margin-top: 0.5rem;
    }
</style>

<script>
    export default {
        data() {
            return {
                errors: [],
            };
        },
        methods: {

            uploadTemplate() {
                let vm = this;  
                vm.errors = [];
                if(vm.$refs.file.files.length==0) {
                    vm.$store.dispatch("error", "The given data was invalid.");
                    let error = ["The excel file is required."];
                    vm.errors.push(error);
                }    
                else {
                    let loader = vm.$loading.show();
                    const formData = new FormData();
                    formData.append("file", vm.$refs.file.files[0]);
                    vm.$store.dispatch("uploadFile", { uri: "importTemplates", data: formData })
                    .then(function () {
                        loader.hide();
                        vm.$store.dispatch("success", "File uploaded successfully");
                        vm.reset();
                    })
                    .catch(function (error) {
                        loader.hide();
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
                }
            },

            reset() {
                let vm = this;  
                var file = document.getElementById("file");
                if (file.files.length > 0) {
                    file.value = null;
                }
                vm.errors = [];
            }
        },
    };
</script>
